module.exports = __webpack_public_path__ + "static/img/daily.cf6ef950.png";